// JS file for EssayItem
